import { HeaderText as SharedHeaderText } from '../../components/atomic/text/header_text/HeaderText';
import titleTextImg from '../content/title_text.png';
import './TitleText.css';

/** From Figma — «АКТУАЛЬНЫЕ ЗАДАНИЯ», top 496 / left 235. */
export function TitleText() {
  return (
    <SharedHeaderText
      className="task-list-title-text"
      src={titleTextImg}
      alt="Актуальные задания"
    />
  );
}
